const mInitialSetup = {
  mInitialSetup: {
    alerts: {
      createAcademia: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La academia fue creada exitosamente.'
      }
    },

    buttonPrimary: 'COMENZAR',

    formInfo: 'Para comenzar a utilizar tu licencia completa los datos de tu academia. Podrás modificar esta información en cualquier momento.',
    gratefulness: 'gracias por elegirnos',
    greeting: 'Hola',

    inputs: {
      categoria: {
        label: 'Categoría de Academia'
      },

      nombre: {
        label: 'Nombre de Academia',
        message: '* De 5 a 60 caracteres',
        placeholder: 'Mi Fantástica Academia'
      },

      url: {
        label: 'Url de Academia',
        message: '* De 3 a 120 caracteres',
        placeholder: 'mi-fantastica-academia'
      }
    },

    validation: {
      categoria: {
        required: 'Categoría de academia es requerida.'
      },

      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Nombre de academia es requerido. De 5 a 60 caracteres.'
      },

      url: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Url de academia es requerida. De 3 a 120 caracteres.'
      }
    }
  }
}

export default mInitialSetup
